/**
 * Initializes Jarvis chat client
 * Based on Adobe Jarvis documentation
 */

import type { JarvisContext, JarvisInitResponse } from './types';

export function initializeJarvis(
  context: JarvisContext
): JarvisInitResponse | null {
  const client = window.AdobeMessagingExperienceClient;

  if (!client) {
    // eslint-disable-next-line no-console
    console.error('Jarvis client not loaded. Call loadJarvisScripts() first.');
    return null;
  }

  try {
    return client.initialize(context);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to initialize Jarvis:', error);
    return null;
  }
}
